<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="applyImport()" autocomplete="off">
          <div class="row">
            <div class="col-md-12">
              <p class="text-muted">
                Arquivo Excel ou CSV contendo apenas a coluna <b>email</b> (ou <b>e_mail</b>).
                As tags selecionadas abaixo serão aplicadas a cada participante encontrado.
                E-mails não cadastrados ficam registrados no log da tarefa.
              </p>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="file">Arquivo</label>
                <b-form-file
                  v-model="form.file"
                  browse-text="Procurar"
                  accept=".xlsx,.xls,.csv"
                  placeholder="Escolha um arquivo para importar"
                  drop-placeholder="Jogue arquivo aqui..."
                  :class="{ 'is-invalid': submitted && !form.file }"
                ></b-form-file>
                <div v-if="submitted && !form.file" class="invalid-feedback d-block">
                  Selecione um arquivo.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="tags">Tags</label>
                <multiselect
                  tag-placeholder="Selecione uma ou mais tags"
                  placeholder="Selecione uma ou mais tags"
                  v-model="form.tags"
                  label="name"
                  track-by="id"
                  :options="tags"
                  :multiple="true"
                  :class="{ 'is-invalid': submitted && (!form.tags || form.tags.length === 0) }"
                ></multiselect>
                <div v-if="submitted && (!form.tags || form.tags.length === 0)" class="invalid-feedback d-block">
                  Selecione ao menos uma tag.
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Modo de ação</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="bylist-replace" value="replace" v-model="form.action_mode">
                    <label class="form-check-label" for="bylist-replace">Substituir tags atuais</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="bylist-append" value="append" v-model="form.action_mode">
                    <label class="form-check-label" for="bylist-append">Adicionar às existentes</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="applyImport()">Executar</button>
    </template>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Multiselect from 'vue-multiselect'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'

export default {
  components: {
    Loading,
    Multiselect
  },
  data () {
    return {
      title: 'Atualização de Tags por Lista',
      loading: false,
      submitted: false,
      modal: false,
      form: {
        file: null,
        tags: [],
        action_mode: 'replace'
      }
    }
  },
  methods: {
    ...mapActions('taskTag', { saveByList: 'saveByList' }),
    ...mapActions('tag', { getAllTags: 'getAll' }),
    loadTags () {
      this.getAllTags({ limit: 100, page: 1 }).catch(err => {
        console.log(err)
      })
    },
    open () {
      this.modal = true
      this.submitted = false
      this.form = { file: null, tags: [], action_mode: 'replace' }
      this.loadTags()
    },
    async applyImport () {
      this.submitted = true
      if (!this.form.file || !this.form.tags || this.form.tags.length === 0) {
        return
      }
      this.loading = true
      try {
        const fd = new FormData()
        fd.append('file', this.form.file, this.form.file.name || 'tags-by-list.xlsx')
        fd.append('tags', JSON.stringify(this.form.tags))
        fd.append('action_mode', this.form.action_mode)
        await this.saveByList(fd)
        successMessage('Sucesso: Lista em processamento. Em alguns minutos as tags serão aplicadas.', 2500)
        this.loading = false
        this.close()
        this.$emit('created')
      } catch (err) {
        this.loading = false
        const msg = (err && err.response && err.response.data && err.response.data.message) || err.message
        errorMessage('Alerta: ' + msg)
      }
    },
    close () {
      this.modal = false
      this.form = { file: null, tags: [], action_mode: 'replace' }
      this.submitted = false
    }
  },
  computed: {
    ...mapState('tag', ['tags'])
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
